export default __webpack_public_path__ + "static/media/Diabolic Pirate Ring.887ddb3c.jpg";